document.addEventListener('DOMContentLoaded', function (event) {
  if (window.innerWidth < 900) {
    comparisonSelectBox();
  }
  showImageVariant();
  buyAndSaveItem();
})



function comparisonSelectBox() {
  let select = document.querySelectorAll('.select-button');
  let options = document.querySelectorAll('.select-option');

  select.forEach(e => {
    e.addEventListener('click', el => {
      const next = el.currentTarget.nextElementSibling;
      next.classList.toggle('open');
    })

    e.addEventListener('mouseenter', el => {
      let innerW, offset, spanW;
      innerW = el.innerWidth;
      spanW = el.querySelector('.selected-product').innerWidth;
      if (spanW > innerW + 1) {
        offset = spanW - innerW;
        el.style.textIndent = -offset;
      }
    })

    e.addEventListener('mouseleave', el => {
      el.style.textIndent = 0;
    })
  })

  options.forEach(e => {
    e.addEventListener('click', elm => {
      selectBox(elm)
    })
  })
}

function selectBox(elm) {
  const parent = elm.currentTarget.closest('.dropdown-wrapper').children[0];
  let dataParent = parent.getAttribute('data-option');
  let currentOrder = elm.currentTarget.parentElement.getAttribute('data-order');
  let dataOther = document.querySelector(`.select-button:not([data-order="${currentOrder}"])`).getAttribute('data-option');

  if (elm.currentTarget.getAttribute('data-option') == dataOther) {
    document.querySelector(`.dropdown-wrapper:not([data-order="${currentOrder}"])`).setAttribute('data-order', currentOrder);
    document.querySelector(`.select-button:not([data-order="${currentOrder}"])`).setAttribute('data-order', currentOrder);
    document.querySelector(`.dropdown-product-wrapper:not([data-order="${currentOrder}"])`).setAttribute('data-order', currentOrder);
    let newOrder = 1 - parseInt(currentOrder);
    parent.setAttribute('data-order', newOrder)
    elm.currentTarget.parentElement.setAttribute('data-order', newOrder);
    elm.currentTarget.closest('.dropdown-wrapper').setAttribute('data-order', newOrder);
    document.querySelectorAll(`[data-category="${dataParent}"]`).forEach((e) => {
      e.style.order = newOrder;
    })
    document.querySelectorAll(`[data-category="${dataOther}"]`).forEach((e) => {
      e.style.order = currentOrder;
    })
    document.querySelector('.dropdown-wrapper[data-order="1"]').style.order = 1;
    document.querySelector('.dropdown-wrapper[data-order="0"]').style.order = 0;
  } else {
    let dataParent = elm.currentTarget.getAttribute('data-option');
    let currentMatchedCategory = document.querySelectorAll(`[data-category="${parent.getAttribute('data-option')}"]`);
    currentMatchedCategory.forEach((e) => {
      e.style.order = '2';
      e.classList.add('md-hidden');
    })

    parent.setAttribute('data-type', elm.currentTarget.getAttribute('data-type'));
    parent.setAttribute('data-option', elm.currentTarget.getAttribute('data-option'));
    parent.querySelector('.selected-product').innerText = elm.currentTarget.innerText;

    let matchedCategory = document.querySelectorAll(`[data-category=${dataParent}]`);
    matchedCategory.forEach((e) => {
      e.classList.remove('md-hidden')
      e.style.order = elm.currentTarget.parentElement.getAttribute('data-order');
    })
  }
  elm.currentTarget.parentElement.classList.remove('open');
}


function showImageVariant() {
  let btns = document.querySelectorAll('.btn-comparison');

  btns.forEach(btn => {
    let wrapper = btn.closest('.category_products__item');
    let form = btn.closest('form');
    let variantData = JSON.parse(form.querySelector('[data-variants-item]').innerHTML);
    btn.addEventListener('click', bt => {
      btn.closest('.product-grid-swatch_item').querySelector('.btn-comparison.selected').classList.remove('selected');
      bt.currentTarget.classList.add('selected');
      let options = Array.from(
        form.querySelectorAll(".btn-comparison.selected"),
        (select) => select.dataset.value
      );
      let selected_variant = variantData.find((variant) => {
        return variant.options.every((vopt) =>
          options.some((opt) => opt === vopt)
        )
      });
      if (selected_variant) {
        form.querySelector('input[name="id"]').value = selected_variant.id;
        let imgItem = wrapper.querySelector(`[data-image-id="${selected_variant.featured_image.id}"]`);
        wrapper.querySelectorAll('[data-image-id]').forEach(w => w.classList.add('hide'));
        imgItem.classList.remove('hide');
      }
    })
  })
}

function buyAndSaveItem() {
  document.querySelectorAll('.category_products__item').forEach(compItem => {
    let dataComparison = compItem.getAttribute("data-comparison");
    let comparePrice, quantity, productPrice;

    if (dataComparison === 'compare-page--buy-and-save') {
      compItem.querySelectorAll('.buy-and-save__item button').forEach(i => {
        i.addEventListener('click', function (e) {
          document.querySelectorAll(".buy-and-save__item button").forEach(b => b.classList.remove('selected'));
          i.classList.add('selected');
          quantityCurrent = i.getAttribute("data-quantity");
          comparePrice = compItem.querySelector('.ComparePrice');
          productPrice = compItem.querySelector('.ProductPrice');
          i.checked = false;
          if (quantityCurrent == 1) {
            i.checked = true;
            productPrice.innerText = "$139.00";
            setTimeout(function () {
              comparePrice.innerText = "$160.00"
            },
              10);
          } else if (quantityCurrent == 2) {
            i.checked = true
            productPrice.innerText = "$119.00"

            setTimeout(function () {
              comparePrice.innerText = "$160.00"
            },
              10);

          } else if (quantityCurrent >= 3) {
            i.checked = true
            productPrice.innerText = "$109.00"

            setTimeout(function () {
              comparePrice.innerText = "$160.00"
            },
              10);
          }
          atcComparison(e.currentTarget, quantityCurrent);
        })
      });
    } else if (dataComparison === 'compare-page--buy-and-save-new') {
      compItem.querySelectorAll('.buy-and-save__item button').forEach(i => {
        i.addEventListener('click', function (e) {
          document.querySelectorAll(".buy-and-save__item button").forEach(b => b.classList.remove('selected'));
          i.classList.add('selected');
          comparePrice = compItem.querySelector('.ComparePrice');
          quantityCurrent = i.getAttribute("data-quantity")
          productPrice = compItem.querySelector('.ProductPrice');
          i.checked = false;
          if (quantityCurrent == 1) {
            compItem.querySelector(".buy-and-save-1").checked = true;
            productPrice.innerText = "$129.00";
            setTimeout(function () {
              comparePrice.innerText = "$140.00"
            },
              10);

          } else if (quantityCurrent == 2) {
            compItem.querySelector(".buy-and-save-2").checked = true
            productPrice.innerText = "$109.00"

            setTimeout(function () {
              comparePrice.innerText = "$140.00"
            },
              10);

          } else if (quantityCurrent >= 3) {
            compItem.querySelector(".buy-and-save-3").checked = true
            productPrice.innerText = "$99.00"
            setTimeout(function () {
              comparePrice.innerText = "$140.00"
            },
              10);
          }
          atcComparison(e.currentTarget, quantityCurrent);
        })
      });
    }
  });
}

function atcComparison(el, qty) {
  let wrapper = el.closest('.category_products__item');
  wrapper.querySelector('input[name="quantity"]').value = qty;
  let form = el.closest('form');
  let formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(response => {
      ajaxCart.load();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

$(document).ready(function (){
  let currentScrollY = 0
  let lastScrollY = 0
  let offset = $('#shopify-section-header').height()
  function toggleHeader() {
    currentScrollY = $(window).scrollTop()
    if (currentScrollY < lastScrollY && currentScrollY > offset) {
      $('#shopify-section-header').removeClass('is-hidden')
    } else if (currentScrollY > lastScrollY && currentScrollY > offset) {
      $('#shopify-section-header').addClass('is-hidden')
    } else {
      $('#shopify-section-header').removeClass('is-hidden')
    }
    lastScrollY = currentScrollY
  }
  $(window).scroll(function (){
    toggleHeader()
  })
})